/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import type Protocol from "parog-web/models/protocol";
import emberSwal from "ui-kit/utils/ember-swal";

export interface PauseOkChimiButtonArgs {
  canBePaused: boolean;
  protocolModel: Protocol;
  preTreatmentSynthesisRoute?: string;
}

export default class TreatmentHistoryProtocolUtilsProtocolSectionPauseOkChimioButtonComponent extends Component<PauseOkChimiButtonArgs> {
  @service declare router: RouterService;

  pauseTreatmentTask = task(async () => {
    const result = await emberSwal.fire({
      title: "Mettre en pause la cure",
      text: "Cette action redirige vers la synthèse de traitement avant de valider la mise en pause. Voulez vous continuer ?",
      icon: "question",
      cancelButtonText: "Annuler",
      showCancelButton: true,
      confirmButtonText: "Voir la synthèse"
    });

    if (result.value && this.args.preTreatmentSynthesisRoute) {
      this.router.transitionTo(this.args.preTreatmentSynthesisRoute);
    }
  });
}
